import { trackEvent } from '@domain/analytics/trackEvent';
import { logger } from '@lib/logger/logger';
import { HandleMapIconClick } from '../types/types';

import { checkAndReturnWaypointIconData } from './mapHelpers';

export const handleWaypointIconClick: HandleMapIconClick = ({
  layerId,
  event,
  map,
  setSelectedIcon,
}) => {
  logger.debug('Waypoint icon click');

  const latitude = event.lngLat.lat;
  const longitude = event.lngLat.lng;

  const features = map.queryRenderedFeatures(event.point, {
    layers: [layerId],
  });

  if (features.length < 1) {
    throw new Error(
      `No Id was found when clicking that icon - Lat: ${latitude}, Lng: ${longitude}`,
    );
  }

  const waypointId = checkAndReturnWaypointIconData(features, longitude, latitude);

  trackEvent({
    name: 'mykiss_explore_marker_clicked',
    properties: {
      type: 'waypoint',
    },
  });

  setSelectedIcon({
    drawerViewId: waypointId,
    drawerView: 'waypoint',
    latitude,
    longitude,
  });
};
